(() => {
  function initialize(root = document) {
    const dialog = document.querySelector('[data-sf-image-dialog]');
    root.querySelectorAll('[data-sf-lightbox]').forEach(link => {
      if (link.dataset.sfLightboxReady || !dialog) return;
      link.dataset.sfLightboxReady = 'true';
      link.addEventListener('click', event => {
        event.preventDefault();
        const image = dialog.querySelector('img');
        image.src = link.href;
        image.alt = link.getAttribute('aria-label') || link.querySelector('img')?.alt || '';
        dialog.querySelector('p').textContent = image.alt;
        dialog.showModal();
      });
    });
    if (dialog && !dialog.dataset.sfReady) {
      dialog.dataset.sfReady = 'true';
      dialog.querySelector('[data-sf-image-close]').addEventListener('click', () => dialog.close());
      dialog.addEventListener('close', () => dialog.querySelector('img').removeAttribute('src'));
      dialog.addEventListener('click', event => { if (event.target === dialog) { const box = dialog.getBoundingClientRect(); if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close(); } });
    }
    root.querySelectorAll('[data-sf-gallery]').forEach(gallery => {
      if (gallery.dataset.sfReady) return;
      gallery.dataset.sfReady = 'true';
      gallery.querySelectorAll('[data-sf-thumb]').forEach(thumb => {
        thumb.addEventListener('click', event => {
          event.preventDefault();
          const image = gallery.querySelector('.sf-main-image');
          if (!image) return;
          image.srcset = [360, 480, 640, 720, 900, 1200].map(width => { const url = new URL(thumb.dataset.full, location.href); url.searchParams.set('width', width); return `${url.href} ${width}w`; }).join(', ');
          image.src = thumb.dataset.full;
          gallery.querySelector('[data-sf-zoom]').href = thumb.dataset.zoom;
          gallery.querySelectorAll('[data-sf-thumb]').forEach(item => item.setAttribute('aria-current', String(item === thumb)));
        });
      });
    });
    root.querySelectorAll('[data-sf-reviews]').forEach(widget => {
      if (widget.dataset.sfReady) return;
      widget.dataset.sfReady = 'true';
      const track = widget.querySelector('[data-sf-review-track]');
      const pause = widget.querySelector('[data-sf-review-pause]');
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      let paused = reduced.matches;
      let hovering = false;
      const updatePause = () => {
        pause.textContent = paused ? '▶' : 'Ⅱ';
        pause.setAttribute('aria-label', paused ? pause.dataset.playLabel : pause.dataset.pauseLabel);
      };
      const move = direction => {
        const cards = [...track.children];
        if (!cards.length) return;
        const index = Math.round(track.scrollLeft / (cards[0].offsetWidth + 14));
        const next = (index + direction + cards.length) % cards.length;
        track.scrollTo({left: next * (cards[0].offsetWidth + 14), behavior: reduced.matches ? 'instant' : 'smooth'});
      };
      widget.querySelector('[data-sf-review-prev]').addEventListener('click', () => move(-1));
      widget.querySelector('[data-sf-review-next]').addEventListener('click', () => move(1));
      pause.addEventListener('click', () => { paused = !paused; updatePause(); });
      widget.addEventListener('mouseenter', () => { hovering = true; });
      widget.addEventListener('mouseleave', () => { hovering = false; });
      track.addEventListener('pointerdown', () => { paused = true; updatePause(); });
      updatePause();
      const timer = setInterval(() => {
        if (!widget.isConnected) { clearInterval(timer); return; }
        if (!paused && !hovering && !document.hidden && !widget.contains(document.activeElement)) move(1);
      }, 3500);
    });
    root.querySelectorAll('[data-sf-main-purchase]').forEach(purchase => {
      if (purchase.dataset.sfReady || !('IntersectionObserver' in window)) return;
      purchase.dataset.sfReady = 'true';
      const sticky = purchase.closest('.sf-hero').querySelector('[data-sf-sticky]');
      const closing = document.querySelector('.sf-closing');
      let purchasePassed = false;
      let closingVisible = false;
      const update = () => { sticky.hidden = !purchasePassed || closingVisible; };
      new IntersectionObserver(entries => {
        purchasePassed = !entries[0].isIntersecting && entries[0].boundingClientRect.bottom < 0;
        update();
      }, {threshold: 0}).observe(purchase);
      if (closing) new IntersectionObserver(entries => {
        closingVisible = entries[0].isIntersecting;
        update();
      }).observe(closing);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize());
  else initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();

